import classNames from 'classnames';
import React from 'react';
import { Decoration_Type } from 'ricos-schema';
import { addAnchorTagToUrl, anchorScroll, normalizeHref } from 'wix-rich-content-common';

const DEFAULTS = {
  config: { linkTypes: { anchor: true } }
};

const LINK_TYPE = "LINK";

var styles = {"fontElementMap":"cN6pV","link":"uxjdX","linkInEditor":"CSdrj","linkInViewer":"D0dNT","toolbarUrlContainer":"_3PJes","toolbarUrl":"ZF1d9","toolbarUrlAnchor":"p9lEl"};

const WEB_LINK = "WebLink";
const ANCHOR_LINK = "AnchorLink";

const decorator$1 = (anchorDecoration, element) => {
  const { anchor } = anchorDecoration.anchorData;
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      key: `anchor-${element == null ? void 0 : element.key}`,
      target: "_self",
      href: `#viewer-${anchor}`,
      className: classNames(styles.link, styles.linkInViewer),
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        const anchorString = `viewer-${anchor}`;
        const element2 = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        anchorScroll(element2);
      },
      "data-hook": ANCHOR_LINK
    },
    element
  );
};
const AnchorDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.ANCHOR));
  },
  decorate: ({ element, node }) => {
    var _a, _b;
    const anchorDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.ANCHOR
    );
    return decorator$1(anchorDecoration, element);
  },
  priority: 1e3
};

const decorator = (element, linkDecoration, contextualData) => {
  var _a;
  const { link: { url, target = contextualData.anchorTarget, rel = {} } = {} } = linkDecoration.linkData;
  const relValue = [
    "noopener",
    rel.nofollow ? "nofollow" : null,
    rel.sponsored ? "sponsored" : null,
    rel.ugc ? "ugc" : null,
    rel.noreferrer ? "noreferrer" : null
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      key: `link=${element.key}`,
      target: `_${(_a = target == null ? void 0 : target.toLowerCase) == null ? void 0 : _a.call(target)}`,
      href: url && normalizeHref(url),
      rel: relValue,
      className: classNames(styles.link, styles.linkInViewer),
      "data-hook": WEB_LINK
    },
    element
  );
};
const LinkDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.LINK));
  },
  decorate: ({ element, node, context }) => {
    var _a, _b;
    const linkDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.LINK
    );
    return decorator(element, linkDecoration, context);
  },
  priority: 1e3
};

const nodeViewDecorators = [
  LinkDecorator,
  AnchorDecorator
];

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginLink = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINK_TYPE,
    nodeViewDecorators
  };
};

export { LINK_TYPE, pluginLink };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-link/dist/es/styles.viewer.min.global.css'